import { createContext } from 'react';
const PageContext = createContext({});
export { PageContext };